<template>
  <Item
    tag="router-link"
    :to="{ name: `${context}-lead`, params: { id: value.id, reference: value.reference.id } }"
    :type="value.typename.toLowerCase()"
    :is-new="!value.isProcessed"
    :title="value.contact.name"
  >
    <template #datetime>
      <FontAwesomeIcon :icon="['fal', 'calendar']" style="margin-right: 3px" />
      {{ value.scopesUpdatedAt | Moment('DD. MMM [kl.] HH.mm') }}
    </template>

    <template #details>
      <div v-if="$route.name === 'dashboard'">
        <FontAwesomeIcon :icon="['fal', 'drafting-compass']" style="margin-right: 3px" />
        {{ value.reference.name }}
      </div>
    </template>
  </Item>
</template>

<script>
import Item from '@/components/ListItem'
import { LeadPathByModel } from '@/components/Lead/utils'
import { Moment } from '@/filters'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    context() {
      return LeadPathByModel[this.$path('reference.onModel', this.value) || 'Project']
    },
  },
  filters: {
    Moment,
  },
  components: {
    Item,
  },
}
</script>

<style lang="scss">
.list-item--lead {
  a {
    text-decoration: none;
  }
}
</style>
